module.exports = __webpack_public_path__ + "static/media/6S.4af6a985.svg";